import React, { createContext, PropsWithChildren, useState } from 'react';
import { getDefaultCurrency, restoreCurrencySelection, saveCurrencySelection } from '@/lib/currency/currency-persistence';

export interface ICurrencyContext {
  currency: string;
  setCurrency: (currency: string) => void;
}

export const CurrencyContext = createContext<ICurrencyContext>({
  currency: getDefaultCurrency(),
  setCurrency: () => {},
});

export const CurrencyContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [currency, setCurrency] = useState<string>(restoreCurrencySelection());
  const initialContext: ICurrencyContext = {
    currency: currency,
    setCurrency: (currency) => {
      saveCurrencySelection(currency);
      setCurrency(currency);
    },
  };
  return <CurrencyContext.Provider value={initialContext}>{children}</CurrencyContext.Provider>;
};
